
import axios from 'config/axiosConfig'
import api, { admin_assessments, reading_assessment } from 'keys/apis'

export const getWordsAndRegionsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/${api.get_words_and_regions}/`)
}

export const getRegionsFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/get_regions/`)
}


export const saveRegionsFetch = ({ id, regions }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/${api.save_regions}/`, {
        regions
    })
}



export const generateCleanAudioFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/generate_clean_audio/`)
}


export const createAudioVersionFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/create_audio_version/`)
}


